<!--
 * @Author: Mr.Cong Wei
 * @Date: 2022-12-12 16:58:48
 * @LastEditTime: 2022-12-12 17:11:05
-->
<template>
  <svg t="1717387241730" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
    p-id="5305" width="16" height="16">
    <path
      d="M275.692308 897.575385V127.606154c0-35.84 36.312615-62.424615 72.152615-41.511385 28.750769 16.817231 603.175385 355.249231 652.209231 384.196923a48.285538 48.285538 0 0 1 0 83.416616c-35.288615 21.228308-611.918769 361.432615-653.666462 385.063384C315.785846 956.140308 275.692308 936.999385 275.692308 897.575385"
      fill="#bd9e55" p-id="5306"></path>
  </svg>

</template>

<script setup lang="ts"></script>

<style scoped></style>
